<template>
  <tr>
    <td class="text-left">
      <p class="title">{{ from }}</p>
    </td>
    <td :colspan="diff" class="pt-8 pb-8 td-none">
      <v-slider
        v-model="range"
        v-on:input="updateValue"
        class="align-center pa-0"
        label=""
        color="amber"
        :max="max"
        :min="min"
        hide-details
        thumb-color="amber black--text"
        thumb-label="always"
        :thumb-size="28"
        track-color="amber accent-1"
      ></v-slider>
    </td>
    <td class="text-right">
      <p class="title">{{ to }}</p>
    </td>
  </tr>
</template>

<script>
// @ is an alias to /src
export default {
  name: "TovRow",
  data() {
    return {
      range: this.value,
    };
  },
  watch: {
    value: {
      handler: function(val) {
        this.range = val;
      },
      deep: true,
    },
  },
  props: {
    value: Number,
    from: String,
    to: String,
    max: {
      type: Number,
      default: 3,
    },
    min: {
      type: Number,
      default: -3,
    },
  },
  methods: {
    updateValue() {
      this.$emit("input", this.range);
    },
  },
  computed: {
    diff() {
      return Math.abs(this.min) + Math.abs(this.max) + 1;
    },
  },
};
</script>

<style lang="scss">
.theme--dark.v-data-table {
  background: none !important;
}
.theme--dark.v-data-table
  tbody
  tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  transition: background 0.3s ease-out;
  background: none;
}
.theme--dark.v-data-table
  tbody
  tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #2b2b2b !important;
}
.theme--dark.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  padding: 0 !important;
}
</style>
